import React from 'react';
import { useNavigate } from 'react-router-dom';
import { subDays } from 'date-fns';
import {
    Grid,
    IconButton,
    Toolbar,
    Tooltip,
    Typography,
    styled,
} from '@mui/material';
import Icon from '@mdi/react';
import { mdiArrowLeft, mdiCalendarRange } from '@mdi/js';

import ActiveFilterChip from '../Filters/ActiveFilterChip';

const classesPrefix = 'healthToolbar';

const classes = {
    toolbar: `${classesPrefix}-toolbar`,
    toolbarButton: `${classesPrefix}-toolbarButton`,
};

const StyledToolbar = styled(Toolbar)(({ theme }) => {
    return {
        [`&.${classes.toolbar}`]: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.getContrastText(theme.palette.primary.main),
        },
        [`& .${classes.toolbarButton}`]: {
            color: 'inherit',
            '&:hover': {
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.common.white,
            },
            '&:disabled': {
                opacity: 0.75,
                color: theme.palette.secondary.main,
                backgroundColor: theme.palette.common.white,
            },
        },
    };
});

const HealthToolbar = ({
    pageTitle,
}: {
    pageTitle: string;
}): React.JSX.Element => {
    const navigate = useNavigate();

    return (
        <StyledToolbar variant='dense' className={classes.toolbar}>
            <Grid
                container
                spacing={1}
                sx={{
                    alignItems: 'center',
                }}
            >
                <Grid item>
                    <Tooltip title='Go Back' placement='top'>
                        <IconButton
                            className={classes.toolbarButton}
                            size='small'
                            onClick={(): void => {
                                navigate(-1);
                            }}
                        >
                            <Icon path={mdiArrowLeft} size={1} />
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Typography>{pageTitle}</Typography>
                </Grid>
                <Grid item>
                    <ActiveFilterChip
                        tooltip='Date Range'
                        label={`${(subDays(new Date(), 31)).toLocaleDateString()} - ${(subDays(new Date(), 1)).toLocaleDateString()}`}
                        icon={mdiCalendarRange}
                        isClickable={false}
                    />
                </Grid>
            </Grid>
        </StyledToolbar>
    );
};

export default HealthToolbar;
